export default "__VITE_ASSET__HKmIG$qx__"